import React, { useContext, useEffect, useState } from "react";
import { userContext } from "../context/UserContext";
import { formatDateTime, url } from "../helpers";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";
import Loader from "./Loader";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const ChooseDateTime = ({ showModal, address, OnSuccess, customer }) => {
  const { user, setLoad } = useContext(userContext);
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState("11:00");
  const [selectedAddress, setSelectedAddress] = useState({});
  const [autocompleteRef, setAutoCompleteRef] = useState("");
  const [bookedSlots, setBookedSlots] = useState([])
  const [createAddressData, setCreateAddressData] = useState({
    addressTitle: "",
    address: "",
    city: "",
    country: "",
    pincode: "",
  });
  const { t } = useTranslation();

  async function fetchQaariSlots() {
    const response = await fetch(
      url + `method/husainia.api.get_qaari_order_progress`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${user?.message?.api_key}:${user?.message?.api_secret}`,
        },
        body: JSON.stringify({
          type: "Qaari Zakreen",
          qaari_name: showModal?.details?.parent,
          date: date,
        }),
      }
    );

    const data = await response.json();

    console.log(data);
    setBookedSlots(data?.message?.length > 0 ? data?.message?.filter(item => item?.status == "Payment Pending" || item?.status == "Payment Completed") : [])
  }

  useEffect(() => {
    if (date && showModal?.details?.parent) {
      fetchQaariSlots();
    }
  }, [date]);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCAvFWBSeW_UhPm6XpPHP8y5Fks8qap38I", // Replace with your API key
    libraries: ["places"],
  });

  function addMinutesToTime(timeStr, minutesToAdd) {
    // Split the time string
    const [hours, minutes] = timeStr.split(":").map(Number);

    // Create a Date object using today's date and the input time
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes + minutesToAdd);

    // Format it back to HH:MM
    const newHours = String(date.getHours()).padStart(2, "0");
    const newMinutes = String(date.getMinutes()).padStart(2, "0");

    return `${newHours}:${newMinutes}`;
  }

  if (!isLoaded) return <Loader />;

  async function createOrder() {
    setLoad(true);
    let delivery_address = "";
    if (selectedAddress?.name) {
      delivery_address = selectedAddress?.name;
    } else {
      console.log(createAddressData);
      const send_data = {
        data: {
          name: createAddressData?.addressTitle,
          address_title: createAddressData?.addressTitle,
          address_type: "Shipping",
          address_line1: createAddressData?.address,
          address_line2: createAddressData?.address,
          city:
            createAddressData?.city?.length > 0 ? createAddressData?.city : "-",
          country: createAddressData?.country,
          pincode:
            createAddressData?.pincode?.length > 0
              ? createAddressData?.pincode
              : "01",
          is_primary_address: 0,
          latitude: createAddressData?.latitude,
          longitude: createAddressData?.longitude,
          is_shipping_address: 0,
          links: [
            {
              link_doctype: "Customer",
              link_name: customer?.name,
              link_title: customer?.name,
            },
          ],
        },
      };

      const response = await fetch(url + "resource/Address", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${user?.message?.api_key}:${user?.message?.api_secret}`,
        },
        method: "POST",
        body: JSON.stringify(send_data),
      });

      if (response.ok == true) {
        setLoad(false);
        const data = await response.json();
        console.log(data);

        if (data?.data?.name) {
          delivery_address = data?.data?.name;
        }
        // document.getElementById("request-sent-modal-trigger-btn").click();
      } else {
        setLoad(false);
        // toast.error("Internal Server Error!");
      }
    }

    if (delivery_address?.length > 0) {
      submitOrder(delivery_address);
    }
  }

  async function submitOrder(delivery_address) {
    let send_data = {
      data: {
        docstatus: 0,
        user: user?.message?.email,
        customer: customer?.name,
        shipping_address: delivery_address,
        delivery_status: "Not Delivered",
        payment_details: "Non Paid",
        order_date: new Date()
          .toLocaleString()
          .split(",")[0]
          .split("/")
          .reverse()
          .join("-"),
        qaari_zakreen_packages: [
          {
            package_name: showModal?.details?.package_name,
            package_unit_price: showModal?.details?.package_unit_price,
            package_description: showModal?.details?.package_description,
            package_minimum_unit: showModal?.details?.package_minimum_unit,
            package_time: showModal?.details?.package_time,
            qaari_zakreen: showModal?.details?.parent,
          },
        ],
        restaurant_package: [],
      },
    };

    console.log("send_data", send_data);

    const response = await fetch(url + "resource/Order", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${user?.message?.api_key}:${user?.message?.api_secret}`,
      },
      method: "POST",
      body: JSON.stringify(send_data),
    });

    if (response.ok == true) {
      const data = await response.json();
      setLoad(false);
      console.log("order", data);
      if (data?.data?.name) {
        // DeleteCart()
        createOrderProgress(delivery_address, data?.data?.name, customer?.name);
      }
    } else {
      setLoad(false);
      // toast.error('Internal Server Error!')
    }
  }

  async function createOrderProgress(
    delivery_address,
    order_number,
    customer_name
  ) {
    const item = showModal?.details;
    const send_data = {
      data: {
        docstatus: 0,
        shipping_address: delivery_address,
        order_no: order_number,
        status: "Pending Verification",
        is_seen_by_vendor: 0,
        is_seen_by_customer: 1,
        customer: customer_name,
        type: "Qaari Zakreen",
        doc_name: item?.parent,
        package_id: item?.package_id,
        packagename: item?.package_name,
        package_unit_price: item?.package_unit_price,
        package_description: item?.package_description,
        package_minimum_unit: item?.package_minimum_unit,
        order_date_time: formatDateTime(),
        package_time: item?.package_time,
        delivery_date_time: formatDateTime(new Date(date), "date"),
        package_image: item?.pacakge_image,
        from_time: time,
        to_time: addMinutesToTime(time, item?.package_time),
        order_qty: 1,
      },
    };
    const response = await fetch(url + "resource/Order Progress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${user?.message?.api_key}:${user?.message?.api_secret}`,
      },
      body: JSON.stringify(send_data),
    });

    if (response.ok == true) {
      setLoad(false);
      OnSuccess();
    }
  }

  function isTimeSlotBookedWithBuffer(booked_slots, selected_time, durationMinutes, bufferMinutes = 0) {
    const toDate = (timeStr) => {
      const [h, m, s] = timeStr.split(":").map(Number);
      const date = new Date();
      date.setHours(h, m, s || 0, 0);
      return date;
    };

    const selectedStart = toDate(selected_time);
    const selectedEnd = new Date(selectedStart.getTime() + durationMinutes * 60000);

    return booked_slots.some(slot => {
      const slotStart = new Date(toDate(slot.from_time).getTime() - bufferMinutes * 60000);
      const slotEnd = new Date(toDate(slot.to_time).getTime() + bufferMinutes * 60000);

      return (
        selectedStart < slotEnd &&
        selectedEnd > slotStart
      );
    });
  }

  const getYesterday = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };



  return (
    <div
      className="modal login-modal modal-light fade"
      id="Zakiri-Date-Modal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body py-5">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              id="choose-date-time-close-btn"
              aria-label="Close"
            ></button>
            <div className="md-body text-center">
              <div className="modal-logo-div mb-4">
                <h4>
                  <b>{t("zakiriPage.chooseDateTime")}</b>
                </h4>
              </div>
              <div className="login-form">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      className="form-control"
                      id="timepicker-reservation-modal"
                      placeholder="Select Date"
                      min={new Date().toISOString().split("T")[0]}
                      type="date"
                      min={getYesterday()}
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                    
                  </div>
                  <div className="col-md-6 mb-3">
                    <input
                      className="form-control"
                      placeholder="Select Time"
                      type="time"
                      value={time}
                      onChange={(e) => setTime(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group mb-3">
                    <label className="form-label d-block text-start">
                      {t("zakiriPage.addressTitle")}
                    </label>
                    <Autocomplete
                      onLoad={(autocomplete) => {
                        setAutoCompleteRef(autocomplete);
                      }}
                      onPlaceChanged={() => {
                        const place = autocompleteRef?.getPlace();

                        let country = "";
                        let city = "";
                        let pincode = "";

                        place.address_components.forEach((component) => {
                          const types = component.types;
                          if (types.includes("country")) {
                            country = component.long_name;
                          }
                          if (
                            types.includes("locality") ||
                            types.includes("administrative_area_level_2")
                          ) {
                            city = component.long_name;
                          }
                          if (types.includes("postal_code")) {
                            pincode = component.long_name;
                          }
                        });

                        setCreateAddressData({
                          addressTitle: place?.name,
                          address: place?.formatted_address,
                          country,
                          city,
                          pincode,
                          latitude: place.geometry.location.lat(),
                          longitude: place.geometry.location.lng(),
                        });
                      }}
                    >
                      <input
                        className="form-control"
                        type="text"
                        placeholder={t("zakiriPage.enterLocation")}
                      />
                    </Autocomplete>
                  </div>
                </div>
                {address?.length > 0 && (
                  <>
                    <hr />
                    <div
                      className="dark-card-header"
                    >
                      <h5 className="card-title mb-2 text-dark text-start">
                        {t("zakiriPage.savedAddress")}
                      </h5>
                    </div>
                    <div className={'modal-check-box'}>
                      <div className="select-address-box mb-3">
                        {address?.map((item, index) => (
                          <div
                            style={{ color: "black" }}
                            className="selectcheckbox text-start"
                            key={index}
                          >
                            <input
                              type="radio"
                              name="selectaddress"
                              onChange={() => setSelectedAddress(item)}
                            />
                            <label>
                              {item?.address_title} , {item?.city} ,{" "}
                              {item?.country}
                              <br />
                              {item?.pincode}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                  </>
                )}
                {bookedSlots?.length > 0 && <div className={"mb-3 slot-booked"}>
                  <h6 className={"text-dark text-start"}>
                    {t("zakiriPage.bookedTimeSlot")}
                  </h6>
                  <div className={"sb-list"}>
                    {bookedSlots?.map((item, index) => (
                      <div key={index} className={"sb-box"}>{item?.from_time} to {item?.to_time}</div>
                    ))}
                  </div>
                </div>}

                <div className="btn-div mb-3">
                  <button
                    onClick={() => {
                      if (selectedAddress && date && time) {
                        if (bookedSlots?.length > 0) {
                          if (isTimeSlotBookedWithBuffer(bookedSlots, time, showModal?.details?.package_time)) {
                            toast.error("Already Booked Slot In This Range. Please Select Another Slot")
                          } else {
                            createOrder();
                          }
                        } else {
                          createOrder();
                        }
                      } else {
                        console.log(selectedAddress, date, time);
                      }
                    }}
                    className="btn btn-primary text-center w-100 py-3"
                  >
                    {t("zakiriPage.next")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseDateTime;
